module.exports = __webpack_public_path__ + "static/media/TowerIcon.57a310f4.svg";